export default __webpack_public_path__ + "static/media/Coin.2b963a00.svg";